export const COLUMN_BUFFER = 10;
export const LABEL_CONDITION_ID = 'labelCondition';
